/**
 * WARNING :the docs APP makes the assumption of always being ran on the same domain as the Customer App app.
 *
 * Docker setup (nothing required, things should work out of the box):
 * nothing.
 *
 *
 * Local setup:
 * make sure to have /docs/.env.local and add the following string
 * VITE_PROXY_API_URL=http://localhost:3003
 *
 *
 * Example of a local setup:
 * docs: localhost:5173
 * customer_app/client: localhost:3006
 * customer_app/proxy: localhost:3003
 * backend_v2: localhost:3000
 */
export const API_URL =
  import.meta.env.VITE_PROXY_API_URL ?? window.location.origin;

export const CUSTOMER_APP_URL: { [key: string]: string } = {
  dev: 'https://dev-app.inpay.com',
  test: 'https://test-app.inpay.com',
  uat: 'https://uat-app.inpay.com',
  prod: 'https://app.inpay.com'
};
